/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetAdminUserPointsPageListRespVo } from './PageDataGetAdminUserPointsPageListRespVo';
import {
    PageDataGetAdminUserPointsPageListRespVoFromJSON,
    PageDataGetAdminUserPointsPageListRespVoFromJSONTyped,
    PageDataGetAdminUserPointsPageListRespVoToJSON,
    PageDataGetAdminUserPointsPageListRespVoToJSONTyped,
} from './PageDataGetAdminUserPointsPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetAdminUserPointsPageListRespVo
 */
export interface ResponsePageDataGetAdminUserPointsPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetAdminUserPointsPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetAdminUserPointsPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetAdminUserPointsPageListRespVo}
     * @memberof ResponsePageDataGetAdminUserPointsPageListRespVo
     */
    data?: PageDataGetAdminUserPointsPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetAdminUserPointsPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetAdminUserPointsPageListRespVo(value: object): value is ResponsePageDataGetAdminUserPointsPageListRespVo {
    return true;
}

export function ResponsePageDataGetAdminUserPointsPageListRespVoFromJSON(json: any): ResponsePageDataGetAdminUserPointsPageListRespVo {
    return ResponsePageDataGetAdminUserPointsPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserPointsPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetAdminUserPointsPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetAdminUserPointsPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetAdminUserPointsPageListRespVoToJSON(json: any): ResponsePageDataGetAdminUserPointsPageListRespVo {
    return ResponsePageDataGetAdminUserPointsPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserPointsPageListRespVoToJSONTyped(value?: ResponsePageDataGetAdminUserPointsPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetAdminUserPointsPageListRespVoToJSON(value['data']),
    };
}

